export default __webpack_public_path__ + "static/media/nt-home-hero.b9405fb8.jpg";